// extracted by mini-css-extract-plugin
export var centerText = "_5y-8";
export var container = "_5y-0";
export var doughnutContainer = "_5y-7";
export var legend = "_5y-a";
export var legendItemColorDisplay = "_5y-b";
export var legendItemLabel = "_5y-d";
export var legendItemValue = "_5y-c";
export var lg = "_5y-5";
export var maxWidth = "_5y-9";
export var md = "_5y-4";
export var responsive = "_5y-6";
export var sm = "_5y-3";
export var xs = "_5y-2";
export var xxs = "_5y-1";